// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AGax","option":"styles_option__3XGvZ","selected":"styles_selected__3D7o3"};